module.exports = __webpack_public_path__ + "fonts/Roboto-400-cyrillic-ext1.493afe7.woff2";